import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface SessionTimeoutDialogProps {
  open: boolean;
  remainingSeconds: number;
  onContinue: () => void;
  onLogout: () => void;
}

export function SessionTimeoutDialog({ open, remainingSeconds, onContinue, onLogout }: SessionTimeoutDialogProps) {
  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;

  return (
    <Dialog open={open} onOpenChange={() => undefined}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Sessao prestes a expirar</DialogTitle>
          <DialogDescription>
            Voce sera desconectado por inatividade em {minutes}:{String(seconds).padStart(2, "0")}. Deseja continuar?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onLogout}>
            Encerrar agora
          </Button>
          <Button onClick={onContinue}>Continuar sessao</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
